import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { useT } from "@/features/onboarding/i18n";

export function StickyActions({
  isFirst,
  isLast,
  submitting,
  busy = false,
  submitLabel,
  hideBackWhenFirst = false,
  onPrev,
  onNext,
  onSubmit,
}: {
  isFirst: boolean;
  isLast: boolean;
  submitting: boolean;
  busy?: boolean;
  submitLabel: string;
  hideBackWhenFirst?: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
}) {
  const t = useT();
  const showBack = !(hideBackWhenFirst && isFirst);
  return (
    <div
      className="fixed bottom-0 inset-x-0 bg-white border-t border-slate-200"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
        {showBack && (
          <Button
            type="button"
            variant="outline"
            size="lg"
            onClick={onPrev}
            disabled={(hideBackWhenFirst ? false : isFirst) || submitting || busy}
            className="min-w-[88px]"
          >
            {t("wiz.back")}
          </Button>
        )}
        {isLast ? (
          <Button type="button" size="lg" onClick={onSubmit} disabled={submitting || busy} className="flex-1">
            {submitting && <Spinner />}
            {submitting ? t("wiz.submitting") : submitLabel}
          </Button>
        ) : (
          <Button type="button" size="lg" onClick={onNext} disabled={busy} className="flex-1">
            {t("wiz.continue")}
          </Button>
        )}
      </div>
    </div>
  );
}
